import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { auth } from "../firebase";
import { useNavigate } from "react-router-dom";

function Menu() {
    const navigate = useNavigate();
    const [username, setUsername] = useState("");
    const [userData, setUserData] = useState(null);
    const [openMenu, setOpenMenu] = useState(null);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
            if (user && user.email) setUsername(user.email);
        });
        return () => unsubscribe();
    }, []);

    const firstLetter = username.charAt(0).toUpperCase();

    const linkStyle = {
        color: "#fff",
        fontWeight: "500",
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "15px 15px",
        borderRadius: "8px",
        transition: "all 0.3s ease",
        textDecoration: "none",
        borderBottom: "1px solid rgba(255,255,255,0.2)",
        cursor: "pointer",
        position: "relative"
    };

    const linkHover = {
        background: "rgba(101, 98, 96, 0.62)",
        transform: "translateX(2px)"
    };

    const submenuStyle = {
        paddingLeft: "25px",
        background: "rgba(101, 98, 96, 0.62)",
        borderBottom: "1px solid rgba(255, 255, 254, 0.3)",
        display: "block"
    };

    const iconStyle = { fontSize: "20px", width: "45px", textAlign: "center" };
    const arrowIconStyle = { marginLeft: "auto", transition: "0.3s", fontSize: "14px" };

    const menuItems = [
        {
            icon: "fas fa-home", text: "Home", link: "/home"
        },
        {
            icon: "fas fa-box",
            text: "Loans Section",
            submenu: [
                { text: "Loan Category", link: "/loan-category" },
                { text: "Loan Details", link: "/loan-details" },
            ]
        },
        {
            icon: "fas fa-table",
            text: "Insurance Section",
            submenu: [
                { text: "Insurance Category", link: "/insurance-category" },
                { text: "Insurance Details", link: "/insurance-details" },
            ]
        },
        {
            icon: "fas fa-user-friends",
            text: "Loan Customers",
            submenu: [
                { text: "All Customers", link: "/loan-customers" },
                { text: "Active Customers", link: "/loancustomers/Active" },
                { text: "Pending Customers", link: "/loancustomers/Pending" },
                { text: "Rejected Customers", link: "/loancustomers/Rejected" },
            ]
        },
        {
            icon: "fas fa-users",
            text: "Insurance Customers",
            submenu: [
                { text: "All Customers", link: "/insurance-customers" },
                { text: "Active Customers", link: "/insurancecustomers/Active" },
                { text: "Pending Customers", link: "/insurancecustomers/Pending" },
                { text: "Rejected Customers", link: "/insurancecustomers/Rejected" },
            ]
        },
        {
            icon: "fas fa-file",
            text: "Enquiry",
            submenu: [
                { text: "Insurance Enquiry", link: "/insurance-enquiry" },
                { text: "Loan Enquiry", link: "/loan-enquiry" },
                { text: "Cibil Enquiry", link: "/cibil-enquiry" },
            ]
        },
        {
            icon: "fas fa-store",
            text: "Affiliate Section",
            submenu: [
                { text: "Affiliate Products", link: "/affiliate-products" },
                { text: "Affiliate Banks", link: "/affiliate-banks" },
                { text: "Affiliate Sources", link: "/affiliate-sources" },
                { text: "Affiliate Leads", link: "/affiliate-leads" },
            ]
        },
        {
            icon: "fas fa-chart-bar",
            text: "Reports",
            submenu: [
                { text: "Enquiry Report", link: "/enquiry-report" },
                { text: "Cibil Enquiry Report", link: "/cibil-enquiry-report" },
                { text: "Affiliate Leads", link: "/affiliate-leads" },
                { text: "Category Wise Report", link: "/category-wise-report" },
                { text: "Insurance Report", link: "/insurance-report" },
            ]
        }
    ];

    return (
        <aside
            className="main-sidebar"
            style={{
                backgroundImage: `url("/menu.jpg")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",

                color: "#fff",
                height: "100vh",
                width: "260px",
                position: "fixed",
                top: 0,
                left: 0,
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
                display: "flex",
                flexDirection: "column"
            }}
        >
            {/* TOP PROFILE BAR */}
            <div
                style={{
                    textAlign: "center",
                    borderBottom: "1px solid rgba(255,255,255,0.2)",
                    padding: "15px 10px",
                    position: "sticky",
                    top: 0,
                    background: "rgba(219, 66, 0, 0.83)",
                    backdropFilter: "blur(6px)",
                    zIndex: 10,
                }}
            >
                <div
                    style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(255,255,255,0.2)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "28px",
                        fontWeight: "700",
                        margin: "0 auto 10px auto",
                        color: "#fff",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.3)"
                    }}
                >
                    {firstLetter}
                </div>

                <h5 style={{ fontWeight: "600", margin: 0 }}>{username}</h5>
            </div>

            {/* MENU AREA */}
            <div
                className="sidebar-scroll"
                style={{
                    padding: "5px 1px",
                    overflowY: "auto",
                    overflowX: "hidden",
                    flex: 1,
                    height: "calc(100vh - 120px)",
                    paddingBottom: "40px"
                }}
            >
                {menuItems.map((item, index) => (
                    <div key={index} style={{ position: "relative" }}>
                        <motion.div
                            onClick={(e) => {
                                if (item.submenu) {
                                    e.preventDefault();
                                    setOpenMenu(openMenu === index ? null : index);
                                } else if (item.link) {
                                    navigate(item.link);
                                }
                            }}
                            style={linkStyle}
                        // whileHover={linkHover}
                        >
                            <i className={item.icon} style={iconStyle}></i>
                            <span>{item.text}</span>
                            {item.submenu && (
                                <i
                                    className="fas fa-chevron-right arrow-icon"
                                    style={{
                                        ...arrowIconStyle,
                                        transform: openMenu === index ? "rotate(90deg)" : "rotate(0deg)"
                                    }}
                                ></i>
                            )}
                        </motion.div>

                        {item.submenu && openMenu === index && (
                            <motion.div
                                initial={{ height: 0, opacity: 0 }}
                                animate={{ height: "auto", opacity: 1 }}
                                transition={{ duration: 0.3 }}
                                style={{ overflow: "hidden" }}
                            >
                                {item.submenu.map((sub, sIndex) => (
                                    <motion.div
                                        key={sIndex}
                                        onClick={() => { if (sub.link) navigate(sub.link); }}
                                        style={{ ...linkStyle, ...submenuStyle, cursor: "pointer" }}
                                        whileHover={linkHover}
                                    >
                                        • {sub.text}
                                    </motion.div>
                                ))}
                            </motion.div>
                        )}
                    </div>
                ))}
            </div>
        </aside>
    );
}

export default Menu;